import { FOLDER_ICON, FolderItem, FolderWorkflowData } from './listView.utils';
import type { ArchiveItem } from '../Archive/archive.types';

interface HasIdAndParent {
  id: string;
  parentId?: string | null;
}

export function countFilesInFolder(folderId: string, folders: HasIdAndParent[], files: HasIdAndParent[]): number {
  let count = files.filter((f) => f.parentId === folderId).length;

  const subfolders = folders.filter((f) => f.parentId === folderId);
  for (const subfolder of subfolders) {
    count += countFilesInFolder(subfolder.id, folders, files);
  }

  return count;
}

export function calculateArchiveFolderData(folders: ArchiveItem[], workflows: ArchiveItem[]): FolderWorkflowData {
  const data: FolderWorkflowData = {};

  for (const folder of folders) {
    const childFolders = folders.filter((f) => f.parentId === folder.id);
    const childWorkflows = workflows.filter((w) => w.parentId === folder.id);
    const items: FolderItem[] = [];
    childFolders.forEach(() => items.push(FOLDER_ICON));
    childWorkflows.forEach((w) => items.push(w.poster || '/workflow-default-cover.png'));
    data[folder.id] = {
      posters: items.slice(0, 4),
      count: childFolders.length + childWorkflows.length,
    };
  }

  return data;
}
